<template>
  <div class="page">
    <div class="page-content">
			<div class="layoutTop"/>
      <page-nav-bar
        popoverName=""
        :subNavTitle="ServiceDetails"
        ReturnButton>
      </page-nav-bar>
      <div class="container-fluid">

        <!-- Guest Alert -->
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <b-alert v-if="userIsGuest()" variant="warning" show dismissible fade>
              <p>Because you are using a guest account, a number of functionalities have been disabled.</p>
              <p>Please create an account on MoneyRoad to unlock all the functionalities.</p>
            </b-alert>
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 offset-md-1">
            <div class="panel21 panel-default">
              <div class="panel-heading">
                <h4 class="content-block labelAccordionForm">
                  <div v-if="details.direction === '0'">
                    <img src='../../../assets/static/images/icons/inbox_into.png' class="formIcon"/>
                    {{ $t('received.rcvd_verb_past', {itemname: $t(this.$engine.services.getSingularNameFromServiceId(this.$engine.user.currentService.id))}) }}
                  </div>
                  <div v-if="details.direction === '1'">
                    <img src='../../../assets/static/images/icons/inbox_out.png' class="formIcon"/>
                    {{ $t('sent.snt_verb_past', {itemname: $t(this.$engine.services.getSingularNameFromServiceId(this.$engine.user.currentService.id))}) }}
                  </div>
                </h4>
              </div>

              <form-accordion open :title="ServiceDetails">
                <div class="row">
                  <form-read-group-label-input
                    :idLabel="$t('common.rsn')" :inputValue="details.reason">
                  </form-read-group-label-input>
                  <!-- Vérifier si on commente le mandate id ou non -->
                  <!-- <form-read-group-label-input v-if="details.mandateIdentifier"
                    :idLabel="$t('modularLoan.mdt_idtfr')" :inputValue="details.mandateIdentifier">
                  </form-read-group-label-input> -->
                  <form-read-group-label-input
                    :idLabel="$t('common.status.status_label')"
                    :inputValue="getStatusLabel(details.status, details.direction)"
                    :statusIcon="getIcon(details.status, '0')">
                  </form-read-group-label-input>
                </div>

                <div class="row">
                    <form-read-group-label-input
                      :idLabel="$t('common.crdtr_name')" :inputValue="details.creditorName">
                    </form-read-group-label-input>
                    <form-read-group-label-input
                      :idLabel="$t('common.crdtr_mail')" :inputValue="details.creditorIdentifier">
                    </form-read-group-label-input>
                </div>

                <div class="row">
                    <form-write-group-label-input v-if="details.direction === '0' && details.status === '0'"
                      :idLabel="$t('common.my_ibn')" inputType="text" v-model="details.debtorBankAccount" :isMandatory="$engine.user.validateAccess('mandatoryIban')">
                    </form-write-group-label-input>
                    <form-read-group-label-input v-else
                      :idLabel="$t('common.my_ibn')" :inputValue="'XXXXXXXXXXXXXXXXXXXXX' + details.debtorBankAccount.substr(details.debtorBankAccount.length - 4)">
                    </form-read-group-label-input>
                    <form-read-group-label-input v-if="details.creditorBankAccount.length"
                      :idLabel="$t('common.crdt_ibn')" :inputValue="'XXXXXXXXXXXXXXXXXXXXX' + details.creditorBankAccount.substr(details.creditorBankAccount.length - 4)">
                    </form-read-group-label-input>
                </div>


                <div class="row">
                  <form-read-group-label-input
                    :idLabel="$t('common.total_amount_no_currency')" :inputValue="details.amount + ' ' + getCurrencyIcon(details.currency)">
                  </form-read-group-label-input>
                  <form-read-group-label-input
                    :idLabel="$t('common.rqst_date')" :inputValue="details.creationDate | formatDate">
                    <f7-button
                      class="blueBackground col-12 col-sm-6 pain001ViewerButton"
                      @click="viewXML('pain001', details.endToEndId)"
                      v-if="this.$engine.user.currentService.id !== '2' && details.status === '4' && details.direction === '1'">
                      View Transfer Order File
                    </f7-button>
                    <f7-button
                      class="blueBackground col-12 col-sm-6 pain001ViewerButton"
                      @click="viewXML('pacs008', details.endToEndId)"
                      v-if="this.$engine.user.currentService.id !== '2' && details.status === '5' && details.direction === '1'">
                      View Instant Payment File
                    </f7-button>
                  </form-read-group-label-input>
                </div>

                <div class="row justify-content-start">
                  <form-read-group-label-input :formGroupWidth="'3 col-6'"
                    :idLabel="$t('common.deposit_amnt_label')"
                    :inputValue="details.depositAmount + ' ' + getCurrencyIcon(details.currency)">
                  </form-read-group-label-input>
                  <form-read-group-label-input :formGroupWidth="'3 col-6'"
                    :idLabel="$t('modularLoan.deposit_date')"
                    :inputValue="details.depositExecutionDate | formatDate">
                  </form-read-group-label-input>

                  <div class="form-group col-sm-6" v-if="details.installments.length > 0 && details.status !== '0'">
                    <label class="createInvoiceBand">
                      {{ $t('common.pymnts_annoucement', {install_number: details.installments.length}) }}
                    </label>
                    <table class="table table-striped table-bordered table-installment">
                      <thead class="thead-dark">
                        <tr>
                          <th>{{ $t('common.installment_amount') }}</th>
                          <th>{{ $t('common.installment_date') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(execution, index) in details.installments" :key="'execution-' + index">
                          <td>{{execution.amount + ' ' + getCurrencyIcon(details.currency)}}</td>
                          <td>{{execution.date | formatDate }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="details.attachmentId" class="col-sm-6" :class="colorBottomButton">
                    <button round
                    @click="view(details.attachmentId)"
                    class="button-action firstButtonMarginTop"
                    v-if="ifAndroid">
                      <i class="icon fa fa-paperclip"></i>
                      View Attachment
                    </button>
                    <button round
                      v-if="!ifAndroid"
                      @click="view(details.attachmentId)"
                      class="button-action firstButtonMarginTop">
                        <i class="icon fa fa-paperclip"></i>
                        {{ $t('common.dl_item', {itemname: $t(this.$engine.services.getAttachmentName(this.$engine.user.currentService.id))}) }}
                    </button>
                  </div>
                </div>
              </form-accordion>


              <hr v-if="details.direction === '0' && details.status === '0' && details.modificationInstallmentsAllowed === '1'"/>
              <form-accordion open
                v-if="details.direction === '0' && details.status === '0' && details.modificationInstallmentsAllowed === '1'"
                :title="$t('regles_metier.titles.installments')"
                hasDatePicker>
                <b-row class="justify-content-start">
                  <b-col sm="6">
                    <div class="form-group">
                      <label>{{ $t('regles_metier.select_nb_installments') }}</label>
                    </div>
                  </b-col>
                  <b-col sm="6">
                    <div class="form-group">
                      <select v-if="details.hasInstallmentRules === '1'" class="form-control" v-model="payNumber">
                        <option v-for="nb in $R.range(parseInt(details.installmentRules.nbInstallments.min), parseInt(details.installmentRules.nbInstallments.max)+1)"
                                :value="nb">
                                {{nb}}
                        </option>
                      </select>
                      <b-form-input v-else v-model="payNumber" type="number"/>
                    </div>
                  </b-col>
                </b-row>
                <echeancier
                  :numPay="payNumber"
                  :min="borneInf"
                  :amount="details.amount"
                  :ccy="'€'"
                  :deposit="details.depositAmount"
                  v-model="multi"/>
              </form-accordion>

              <hr v-if="details.hasInstallmentRules === '1' && details.modificationInstallmentsAllowed === '1'"/>
              <form-accordion :open="false"
                v-if="details.hasInstallmentRules === '1' && details.modificationInstallmentsAllowed === '1'"
                :title="$t('regles_metier.titles.rules_details')">
                <regles-details :reglesMetier="details.installmentRules"></regles-details>
              </form-accordion>

            </div>
          </div>
        </div>


      <div v-if="details.direction === '0' && details.status === '0'"
          class="row justify-content-start inboxDetailButton"
          v-bind:class="colorBottomButton">
        <div class="col-md-5 offset-md-1">
          <button round
          class="button-action firstButtonMarginTop"
           @click="refuseSDD()">
            <i class="icon fa fa-ban"></i>
              {{ $t('common.refus') }}
          </button>
        </div>
        <!-- <div class="col-md-3">
          <button round
          class="button-action firstButtonMarginTop">
            <i class="icon fa fa-check"></i>
              {{ $t('common.negot') }}
          </button>
        </div> -->
        <div class="col-md-5">
          <button round
          class="button-action firstButtonMarginTop"
            @click="acceptSDD()">
            <i class="icon fa fa-check"></i>
              {{ $t('common.accpt') }}
          </button>
        </div>
      </div>



      </div> <!-- End Container Fluid -->
      <div class="layoutBottom"></div>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
		<!-- </f7-page> -->
	<!-- </div> -->
</template>

<script>
import b64toBlob from 'b64-to-blob'
import moment from 'moment'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import {statusIcon} from '@/helpers/labels'
import FormAccordion from '@/components/common/FormAccordion.vue'
import ReglesDetails from '@/pages/reglesEcheancier/EcheancierReglesDetails.vue'
import Echeancier from '@/pages/requests/EcheancierForm.vue'
import {updateToSeen} from '@/helpers/storage'

/** TLV 24/03/2020
* Component qui gère les détails des demandes reçues et envoyées.
* A l'heure actuelle ne fonctionne que sur modular loan, mais il est prévu de faire
* fonctionner ce component sur tous les services.
*/
export default {
  name: 'transaction-details',
  props: ['direction'],
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-accordion': FormAccordion,
    'regles-details': ReglesDetails,
    'echeancier': Echeancier
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      details: {},
      ServiceDetails: '',
      payNumber: 1,
      multi: []
    }
  },
  created () {
    this.ServiceDetails = this.$i18n.t('common.item_details',
      {itemname: this.$i18n.t(this.$engine.services.getSingularNameFromServiceId(this.$engine.user.currentService.id))})
    if (this.direction === '0') {
      this.details = this.$engine.services.getServiceById(this.$engine.user.currentService.id).currentInbox
    } else {
      this.details = this.$engine.services.getServiceById(this.$engine.user.currentService.id).currentSendbox
    }

    if (this.details.currency == null) {
      this.details.currency = 'EUR'
    }
    if (this.details.installments.length > 0) {
      this.payNumber = this.details.installments.length
    } else {
      this.payNumber = (this.borneInf > 0) ? this.borneInf : 1
    }

    this.multi = this.details.installments
    if (this.details.isRead !== '1') {
      updateToSeen(this, this.details.id, 'directDebit')
    }
  },
  computed: {
    ifAndroid: function () {
      if (this.$f7.device.os === 'android') {
        return true
      } else {
        return false
      }
    },
    senderSubtitle () {
      switch (this.details.direction) {
        case '0': return this.$t('common.formsSubTitle.item_info', {itemname: this.$t('common.formsSubTitle.my_acct')})
        case '1': return this.$t('common.formsSubTitle.item_info', {itemname: this.$t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))})
        default: return ''
      }
    },
    receiverSubtitle () {
      switch (this.details.direction) {
        case '0': return this.$t('common.formsSubTitle.item_info', {itemname: this.$t('common.formsSubTitle.sndr')})
        case '1': return this.$t('common.formsSubTitle.item_info', {itemname: this.$t('common.formsSubTitle.my_acct')})
        default: return ''
      }
    },
    borneInf () {
      if (this.details.hasRegles) {
        return this.details.installmentRules.nbInstallments.min
      } else {
        return 1
      }
    }
  },
  methods: {
    hideBlock ($event) {
      let that = this
      if (that.Dom7($event.target).hasClass('card-header')) {
        if (that.Dom7($event.target).next().css('display') === 'none') {
          that.Dom7($event.target).next().show()
          that.Dom7($event.target).find('i').transform('rotate(0deg)')
        } else {
          that.Dom7($event.target).next().hide()
          that.Dom7($event.target).find('i').transform('rotate(-90deg)')
        }
      } else {
        if (that.Dom7($event.target).parent().next().css('display') === 'none') {
          that.Dom7($event.target).parent().next().show()
          that.Dom7($event.target).parent().find('i').transform('rotate(0deg)')
        } else {
          that.Dom7($event.target).parent().next().hide()
          that.Dom7($event.target).parent().find('i').transform('rotate(-90deg)')
        }
      }
      // that.$$('.page-content').scrollTop(that.Dom7($event.target).offset().top - that.$$('.page-content').offset().top + that.$$('.page-content').scrollTop() + 300, 400)
      that.$$('.page-content').scrollTop(that.Dom7($event.target).offset().top + that.$$(that.$$('.page-content')[that.$$('.page-content').length - 1]).offset().top - 96, 400)
    },
    getStatusLabel (status, direction) {
      switch (status) {
        case '0':
          return this.$t('common.status.waiting_request')
        case '1':
          return this.$t('common.status.accepted_request')
        case '3':
          return this.$t('common.status.aborted_request')
        case '4':
          if (direction === '0') {
            return this.$t('common.status.trsction_received')
          } else {
            return this.$t('common.status.norml_payment_sent')
          }
        case '5':
          if (direction === '0') {
            return this.$t('common.status.inst_payment_recivd')
          } else {
            return this.$t('common.status.inst_payment_sent')
          }
        case '20':
          return this.$t('common.status.information')
        default:
          return this.$t('common.status.unknown')
      }
    },
    getIcon (status, negotStatus) {
      return statusIcon(status, negotStatus)
    },
    /* Only work for downloading files on Mobile devices */
    download (id) {
      /* eslint-disable no-undef */
      const that = this
      this.$f7.showPreloader('Downloading File')
      this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          that.writeToFile(
            response.data.documentName,
            response.data.documentData,
            response.data.documentData.split(';')[0].replace(/^data:/, ''),
            false,
            function (filePath, fileType) {
              that.$f7.alert(filePath.split('/')[filePath.split('/').length - 1], 'Following file successfully saved.')
            },
            function () {
              that.$f7.alert('', 'Error creating the file')
            }
          )
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
      /* eslint-enable no-undef */
    },
    view: function (id) {
      const that = this
      this.$f7.showPreloader('Opening File')
      this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.writeToFile(
              response.data.documentName,
              response.data.documentData,
              response.data.documentData.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              }
            )
          } else {
            let blob = b64toBlob(response.data.documentData.split(',')[1], response.data.documentData.split(';')[0].replace(/^data:/, ''))
            const url = window.URL.createObjectURL(blob)
            const fileLink = document.createElement('a')
            fileLink.href = url
            fileLink.setAttribute('download', response.data.documentName) // or any other extension
            fileLink.click()
          }
          setTimeout(function () { that.$f7.hidePreloader() }, 1000)
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
          // errorMessageAlert(error, that)
        })
    },
    viewXML: function (type, id) {
      // Get cloudDocument
      // var resource = 'attachment/detail/' + id
      let service = 'directPayment'
      const that = this
      this.$f7.showPreloader('Opening File')
      this.$engine.services.payments.getXMLDetail(service, type, id)
        .then(response => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({type: {
            data: response.data.data
          }})
          if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.writeToFile(
              service + '_' + type + '_' + id + '.xml',
              response.data.data,
              response.data.data.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              })
          } else { // browser
            let blob = b64toBlob(response.data.data.split(',')[1], 'text/xml')
            const url = window.URL.createObjectURL(blob)
            const fileLink = document.createElement('a')
            fileLink.href = url
            let today = moment().format()
            let filename = 'Transfer_Order_' + today
            if (type === 'pacs008') {
              filename = 'Instant_Payment_' + today
            }
            fileLink.setAttribute('download', filename) // or any other extension
            fileLink.click()
          }
        })
        .catch(error => {
          that.$f7.hidePreloader()
          console.log(error)
          // errorMessageAlert(error, that)
        })
    },
    writeToFile (fileName, data, fileType, readonly, success, error) {
      /* eslint-disable no-undef */
      let that = this
      let directory = ''

      if (readonly) {
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalDataDirectory
        } else if (that.$f7.device.os === 'ios') {
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        that.saveFileToDirectory(fileName, data, fileType, directory, success, error)
      } else {
        // directory = cordova.file.externalRootDirectory
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalRootDirectory
        } else if (that.$f7.device.os === 'ios') {
          // directory = cordova.file.dataDirectory
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        try {
          that.checkForWritePermissions(function () {
            try {
              window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
                directoryEntry.getDirectory('Download', {create: true}, function (downloadDir, _data) {
                  that.saveFileToDirectory(fileName, data, fileType, downloadDir.nativeURL, function (filePath, fileType) {
                    // console.log('sucess saving file: ', filePath)
                  }, function (error, _data) {
                    // console.error('error on saving file' + error.code)
                    alert('Unable to save file: ' + error.code)
                  })
                }, function (error, _data) {
                  console.error('error on accessing download directory' + error.code)
                  alert('Unable to get/create download directory: ' + error.code)
                })
              }, (e, file) => { // error resolveLocalFileSystemURL
              })
            } catch (error) { // get dir
              console.error(error)
            }
          }, function () {
            alert('App needs access to the phone\'s file storage in order to save files.')
          })
        } catch (error) { // get perms
          console.error(error)
        }
      }
      /* eslint-enable no-undef */
    },
    checkForWritePermissions (sucess, error) {
      /* eslint-disable no-undef */
      if (this.$f7.device.os === 'android') {
        cordova.plugins.diagnostic.requestRuntimePermission(function (status) {
          switch (status) {
            case cordova.plugins.diagnostic.permissionStatus.GRANTED:
              sucess()
              break
            case cordova.plugins.diagnostic.permissionStatus.DENIED:
              error()
              break
            case cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
              error()
              break
          }
        }, function (error) {
          console.error('The following error occurred: ' + error)
        },
          cordova.plugins.diagnostic.permission.WRITE_EXTERNAL_STORAGE
        )
      } else if (this.$f7.device.os === 'ios') {
        sucess()
      }
      /* eslint-enable no-undef */
    },
    saveFileToDirectory (fileName, data, fileType, directory, success, error) {
      /* eslint-disable no-undef */
      let directoryEntryReference = null
      window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
        directoryEntryReference = directoryEntry
        directoryEntry.getFile(fileName, { create: true, exclusive: true }, function (fileEntry) {
          fileEntry.createWriter(function (fileWriter) {
            fileWriter.onwriteend = function (e) {
              success(e.target.localURL, fileType, fileName)
            }
            fileWriter.onerror = function (e) {
              error()
            }
            let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
            fileWriter.write(blob)
          }, (e, file) => {
          })
        }, (e, file) => {
          navigator.notification.confirm('This file already exists do you want to override it ? (' + fileName + ')', function (index) {
            // console.log('Do you want to override the following file: ' + fileName + ' (' + index + ')')
            switch (index) {
              case 1: // No
                // console.log('No. Returning to idle state.')
                break
              case 2: // Yes -> overrides  the file
                // console.log('Yes. Overriding file.')
                directoryEntryReference.getFile(fileName, { create: true, exclusive: false }, function (fileEntry) {
                  fileEntry.createWriter(function (fileWriter) {
                    fileWriter.onwriteend = function (e) {
                      success(e.target.localURL, fileType, fileName)
                    }
                    fileWriter.onerror = function (e) {
                      error()
                    }
                    let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
                    fileWriter.write(blob)
                  }, (e, file) => {
                  })
                }, (e, file) => {
                })
                break
            }
          }, 'Information', ['No', 'Yes'])
        })
      }, (e, file) => { // error resolveLocalFileSystemURL
      })
      /* eslint-enable no-undef */
    },
    readFile (filePath, fileType, fileName) {
      /* eslint-disable no-undef */
      // TODO : test fileType before trying to open and let the user know
      window.resolveLocalFileSystemURL(filePath, function (entry) {
        cordova.plugins.fileOpener2.open(entry.nativeURL.replace(/%20/g, ' '), fileType, {
          error: function (e) {
            // TODO : screen user stuff
          },
          success: function (s) {
            // TODO : screen user stuff
          }
        })
      })
    },
    returnBack () {
      this.$f7.mainView.router.back()
    },
    acceptSDD () {
      let that = this
      const sortByDate = this.$R.sortBy(this.$R.prop('date'))
      const multPmtsSorted = sortByDate(this.multi)
      this.$engine.services.directDebit.answerSDD(
        that.details.creditorIdentifier,
        that.details.creditorName,
        that.details.creditorBankAccount,
        that.details.debtorIdentifier,
        that.details.debtorName,
        that.details.debtorBankAccount,
        that.details.mandateIdentifier,
        'true',
        that.details.reason,
        that.details.depositAmount,
        that.details.depositExecutionDate,
        that.details.amount,
        that.details.currency,
        multPmtsSorted,
        that.details.msgId
      ).then(response => {
        loadPage(that, {url: '/directDebit/inbox/'})
      })
      .catch(err => {
        let message = this.getTextError(err) // mixins errorHandlerMixins
        if (message !== '') {
          that.$f7.alert(message, this.$t('regles_metier.errors'))
        }
      })
    },
    refuseSDD () {
      let that = this
      this.$engine.services.directDebit.answerSDD(
        that.details.creditorIdentifier,
        that.details.creditorName,
        that.details.creditorBankAccount,
        that.details.debtorIdentifier,
        that.details.debtorName,
        that.details.debtorBankAccount,
        that.details.mandateIdentifier,
        'false',
        that.details.reason,
        that.details.depositAmount,
        that.details.depositExecutionDate,
        that.details.amount,
        that.details.currency,
        [],
        that.details.msgId
      ).then(response => {
        loadPage(that, {url: '/directDebit/inbox/'})
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getCurrencyIcon (ccy) {
      switch (ccy) {
        case 'EUR':
          return '€'
        case 'USD':
          return '$'
        case 'GBP':
          return '£'
        case 'JPY':
          return '¥'
        case 'RUB':
          return '₽'
        default:
          return ccy
      }
    },
    bankLabelHidden (iban, zone) {
      // Bloc ci-dessous a adapter aux multi-devises asap
      /* if (zone === 'UK') {
        return formatIbanUKHidden(iban)
      } else {
        return formatIbanHidden(iban)
      } */
      return iban
    },
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    }
  }
}
</script>
<style scoped>
	.transaction-info {
		/* padding-top: 50px; */
		padding-left: 3%;
		padding-right: 3%;
		width: 94%;
		/* height: 100%; */
		max-height: 100%;
		clear: both;
		margin: 0 auto;
	}
	.modify-actions {
	}
	.changesGrid {
		border-top: 2px solid #fffdb7;
		border-bottom: 2px solid #fffdb7;
		font-weight: bold;
		text-align: center;
		background-color: #fffdb7;
	}
	.firstGridModif {
		border-top: 1px solid #E36608;
		border-bottom: 1px solid #E36608;
		font-weight: bold;
		text-align: center;
		border-radius: 0px 0px 0 0;
		margin-top: 3%;
	}
	.titleGridModif {
		color: #ffffff;
		background-color: #E36608;
		border-radius: 0px 0px 0 0;
	}
	.defaultGridDisplayModif {
		border-left: 2px solid orange;
		border-right: 2px solid orange;
		background-color: #ffffff;
	}
	.lastGridModif {
		border-bottom: 1px solid #12bcf1;
	}
  .zeroHight {
    height: 0px;
  }
  .titleGridExecuted {
    color: #ffffff;
		background-color: #46C03D;
		border-radius: 0px 0px 0 0;
  }
  .subTitlePaymentsInfo {
    color: #000000;
    /* padding: 3px 0px 9px 1%; */
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }
  .iconDetailsPage {
    font-size:15px;
    padding-left:5px;
  }
  .colorRemittanceInfomation {
    color:#144a85
  }
  .bankAccountPaymentsSelectionList {
    /* display: none;
    position: absolute;
    background-color: #f9f9f9; */
    margin:0px;
    list-style: none;
    padding-left: 0 !important;
    max-height: 96px;
    overflow:hidden;
    overflow-y:scroll;

    /* -webkit-appearance: none;
    width: 7px; */
  }
  .bankAccountPaymentsSelectionListContainer{
    display: none;
    position: absolute;
    right: 10px;
    top: 25px;
    /* bottom: 0px; */
    margin-top: 1px;
    background-color: #ffffff;
    border: 1px solid #a9a9a9;
    min-width: 206px;
    z-index: 20;
  }
  .bankAccountPaymentsSelectionInput {
    /* width: 215px; */
    font-size: 12px !important;
    height: auto !important;
    width: 190px !important;
  }
  .bankAccountPaymentsSelectionListItem {
    padding: 8px 8px;
  }
  .closeSelectionListContainerLabel {
    padding: 3px 8px 3px 8px;
    /* text-align: right; */
    /* height: 29px; */
    border-bottom: 1px solid #a9a9a9;
  }
  .rightButton {
    /* float: right; */
    right: 8px;
    top: 3px;
    /* width: 60px; */
    padding: 1px 5px !important;
    position: absolute;
    line-height: normal !important;
  }
  .bankAccountPaymentsSelectionList::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
  }
  .bankAccountPaymentsSelectionList::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0,0,0,.5);
      -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
  }
  .closeSelectionListContainerLabelName {
    line-height: 21px;
  }
  .pain001ViewerBlock {
    display: block !important;
  }
  .pain001ViewerButtonBlock {
    margin-right: 7px !important;
    float: right !important;
    position: relative !important;
    color: #777777;
  }
	/*.button {
		margin-top: 5px;
		margin-bottom: 5px;
	}*/
  .transactionDetailFontSize {
    font-size: 16px !important;
  }
  .transactionDetailHeader{
    color:white;
    background-color: #12bcf1;
    text-align: center;
    font-size: 14px;
    display: block;
    min-height: 0 !important;
    padding: 8px 15px !important;
    /* font-weight: bold; */
  }
  .transactionDetailSubHeader {
    text-align: center !important;
    display: block !important;
    font-weight: bold !important;
  }
  .icon-transaction-detail {
    width: 18px;
    height: 18px;
    background-size: contain;
  }
  .headerChevron {
    float: right;
    font-size: 12px;
    margin-top: 4px;
  }
  .list-block li {
    background-color: #fcfcfc;
  }
  .list-block.item-content {
    padding-left: 0% !important;
  }
  .list-block.inset {
    margin-left: 0%;
  }
</style>



// WEBPACK FOOTER //
// DirectDebitDetailPage.vue?70570a24